import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import GuideMeButton from '../components/GuideMeButton';
import Intro from '../components/Intro';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '34px 10px',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      padding: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  container: {
    [theme.breakpoints.up('1140')]: {
      // width: 1140,
      padding: 0,
    },
    flexDirection: 'column',
    width: '100%',
    padding: '24px 5%',
    '& p': {
      textAlign: 'left',
    },
    '& button': {
      fontSize: 18,
      lineHeight: '23px',
      fontFamily: 'MadaBold',
    },
  },
}));

function VariantK({ otherLanguage }) {
  const classes = useStyles();

  return (
    <div className={classes.root} data-test-id="hero-variant-g">
      <Grid container className={classes.container}>
        <Intro
          isLandingPage={false}
          otherLanguage={otherLanguage}
          twoCardStyle
        />
        <GuideMeButton noGuideMe isCentered otherLanguage={otherLanguage} />
      </Grid>
    </div>
  );
}

export default VariantK;
